/** Display AI confidence as a percentage, capped at 99% to leave room for edge cases. */
export function format_ai_confidence_percent(confidence: number): string {
  const pct = Math.min(99, Math.round(confidence * 100))
  return `${pct}%`
}

if (import.meta.vitest) {
  const { describe, it, expect } = import.meta.vitest

  describe("format_ai_confidence_percent", () => {
    it("caps at 99% for perfect confidence", () => {
      expect(format_ai_confidence_percent(1)).toBe("99%")
      expect(format_ai_confidence_percent(0.995)).toBe("99%")
    })

    it("rounds sub-99% scores normally", () => {
      expect(format_ai_confidence_percent(0.86)).toBe("86%")
      expect(format_ai_confidence_percent(0.856)).toBe("86%")
    })
  })
}
